<template>
    <div>
        <v-dialog v-model="showNewSellLineModal" persistent :max-width="Global.MODAL_WIDTH"  >
            <v-card>
                <v-card-title class="blue-grey darken-2 white--text" style="height: 70px; padding: 0; font-size: 20px">
                    <!--<v-card-title class="white&#45;&#45;text" style="height: 70px; color: #445c67; padding: 0; font-size: 20px">-->
                    <span style="margin-left: 16px">Produto/Serviço</span>
                    <v-spacer></v-spacer>
                    <p v-if="article && article_type === Types.article.PRODUTO"
                       style="font-size: 14px; margin-right: 16px; margin-top: 10px; text-align: right;">
                        <span :style="stockPrevision > 0 ? 'color: #ffffff' : 'color: #f74646'" ><b>Stock Disponível: {{stock}} </b></span>
                        <v-icon small dark>arrow_forward</v-icon>
                        <span>({{stockPrevision ? stockPrevision : stock}})</span>
                        <!--<span>(->{{this.stock}})</span>-->
                        <br>
                        <span :style="stockPrevision > min_stock ? 'color: #ffffff' : 'color: #f74646'"><b>Stock Minimo: {{min_stock ? min_stock : 0}}</b></span>
                    </p>
                </v-card-title>

                <v-container grid-list-md>
                    <v-layout wrap>
                        <!--Artigo-->
                        <v-flex xs12 sm6 md6 px-2>
                            <!--Article-->
                            <v-autocomplete
                                v-model="article"
                                :error-messages="articleErrors"
                                @blur="$v.article.$touch()"
                                @input="onSelectArticleChange"
                                :items="articles"
                                :loading="isLoadingArticles"
                                clearable
                                deletable-chips
                                chips
                                return-object
                                item-text="name"
                                label="artigo..."
                                solo
                                :prefix="article ?
                                    article_type === Types.article.PRODUTO ? 'Produto:' :
                                    article_type === Types.article.SERVICO ? 'Serviço:' : 'Artigo'
                                    : ''"
                            >
                                <template slot="selection" slot-scope="{ item, selected }">
                                    <v-chip :selected="selected" color="blue-grey" class="text-truncate white--text" >
                                        <v-icon left>mdi-coin</v-icon>
                                        <span v-text="item.name"></span>
                                    </v-chip>
                                </template>
                                <template slot="item" slot-scope="{ item }">
                                    <v-list-tile-avatar
                                            @click="gotoAddNewArticle(item.id)"
                                            :color="item.id === -1 ? 'blue' : 'indigo'"
                                            class="headline font-weight-light white--text"
                                    >
                                        {{ item.id === -1 ? '+' : item.name.charAt(0) }}
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-text="item.id === -1 ? 'Adicionar Artigo' : item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon>mdi-coin</v-icon>
                                    </v-list-tile-action>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <!--Detalhe-->
                        <v-flex xs12 sm6 md6 px-2>
                            <v-text-field v-model="detail"
                                  :error-messages="detailErros"
                                  @blur="$v.detail.$touch()"
                                  label="Detalhe"></v-text-field>
                        </v-flex>
                        <!--Quantidade Vendida-->
                        <v-flex xs12 sm6 md2 px-2>
                            <v-text-field type="number"
                                  v-model.number="sold_quantity"
                                  :error-messages="soldQuantityErrors"
                                  :hint="strMinStockHint"
                                  min="1"
                                  persistent-hint
                                  @blur="$v.sold_quantity.$touch()"
                                  label="Quant. vendida"></v-text-field>
                        </v-flex>
                        <!--Quantidade Por entregar-->
                        <v-flex xs12 sm6 md2 px-2>
                            <v-text-field type="number"
                                  v-model="quantity_to_be_delivery"
                                  :hint="strNoStockHint"
                                  min="0"
                                  disabled
                                  persistent-hint
                                  @input="onQuantityPorEntregarInput"
                                  label="Quant. por entregar"></v-text-field>
                        </v-flex>
                        <!--Preço-->
                        <v-flex xs12 sm6 md2 px-2>
                            <v-text-field type="number"
                                  v-model="sell_price"
                                  :error-messages="costValueErros"
                                  @blur="$v.sell_price.$touch()"
                                  label="Preço"></v-text-field>
                        </v-flex>
                        <!--Desconto-->
                        <v-flex xs12 sm6 md3 px-2>
                            <v-text-field type="number"
                                  v-model="discount"
                                  :error-messages="discountErrors"
                                  @blur="$v.discount.$touch()"
                                  :hint="discountHint"
                                  persistent-hint
                                  min="0"
                                  suffix="%"
                                  label="Desconto(%)"></v-text-field>
                        </v-flex>

                        <!--Subtotal-->
                        <v-flex xs12 sm6 md3 px-2>
                            <v-text-field type="number"
                                  v-model="computedSellLineSubtotal"
                                  :error-messages="subtotalErrors"
                                  @blur="$v.subtotal.$touch()"
                                  disabled
                                  label="Subtotal"></v-text-field>
                        </v-flex>

                    </v-layout>
                </v-container>
                <v-card-actions>
                    <!--Sell Lines-->
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" flat="flat" @click="closeSellLineDialog">
                        Cancelar
                    </v-btn>

                    <v-btn color="blue lighten-2 white--text" :disabled="checkSellLineModalConfirmButton()" @click="virtuallyAddNewSellLine">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {Types, Global} from "../../config";
    import {maxLength, maxValue, minValue, required} from 'vuelidate/lib/validators';

    export default {
        name: "ATItemLine",

        beforeDestroy () {
            eventBus.$off('onSellLineModalOpen');
        },

        data(){
            return {
                Global,
                Types,
                article_type: '',

                nonMutableStock: '',
                searchArticleField: ' ',

                isLoadingArticles: false,
                // articles: [],

                article: '',
                detail: '',
                sold_quantity: '',
                sell_price: '',
                stock: '',
                min_stock: '',
                discount: '',
                subtotal: '',
            }
        },

        props: {
            aTItemLineIndexEdit: Number,
            articleTransactionType: Number,
            agreed_discount: Number,
            hasDiscount: {
                type: Boolean,
                default: false,
            },
        },

        validations: {
            article: {
                required
            },
            detail: {
                maxLength: maxLength(60),
            },
            sold_quantity: {
                minValue: minValue(0),
                required
            },
            sell_price: {
                minValue: minValue(0),
                required
            },
            discount: {
                maxValue: maxValue(100),
                minValue: minValue(0)
            },
            subtotal: {
                minValue: minValue(0),
                required
            }
        },

        watch:{
            // searchArticleField(){
            //     this.searchArticle(this);
            // },

            showNewSellLineModal(){
                if(this.showNewSellLineModal){
                    this.onSellLineFormModalOpen();
                }
            },
        },

        methods:{
            onSellLineFormModalOpen(){
                // if(this.hasDiscount){
                    this.discount = this.sellLine && this.sellLine.discount ? this.sellLine.discount : this.agreed_discount;
                    // this.consoleLog('hasDiscount', this.discount);
                // }
                if(this.onSellLineFormModalOpen){
                    this.consoleLog('onSellLineFormModalOpen', this.sellLine);
                    this.article = this.sellLine.article;
                    this.detail = this.sellLine.detail;
                    this.sold_quantity = this.sellLine.sold_quantity;
                    this.sell_price = this.sellLine.sell_price;
                    // this.quantity_to_be_delivery = this.sellLine.quantity_to_be_delivery;
                    // this.discount = this.sellLine.discount;
                    this.subtotal = this.sellLine.subtotal;
                }
            },

            calculateStockPrevision(){

            },

            onQuantityPorEntregarInput(){
                // let vm = this;
                // let article = this.articles.find(function(element){
                //     return element.id === vm.articles_id ? element : undefined;
                // });

                // if(article && this.article_type !== Types.article.SERVICO){

                //     let res = this.sold_quantity - article.stock;
                //     let res2 = this.quantity_to_be_delivery - res;

                //     if(res > 0){
                //         this.sold_quantity += res2;
                //     }
                // }
            },

            onSelectArticleChange(){
                this.consoleLog('article selected', this.article);
                // let vm = this;
                // let article = this.articles.find(function(element){
                //     return element.id === vm.article ? element.id : undefined;
                // });

                this.article_type = this.article ? this.article.types_id : null;

                this.sold_quantity = 1;
                this.sell_price = this.article ? this.article.price : '';
                this.stock = this.article ? this.article.stock : '';
                this.min_stock = this.article ? this.article.min_stock : '';
            },

            checkSellLineModalConfirmButton(){
                // let quantity = (parseInt(this.sold_quantity) + parseInt(this.quantity_to_be_delivery)) > 0;
                // return this.$v.article.$invalid || !quantity
                //     || this.$v.sold_quantity.$invalid;
            },

            closeSellLineDialog(){
                this.article = '';
                this.detail = '';
                this.sold_quantity = '';
                // this.quantity_to_be_delivery = '';
                this.sell_price = '';
                this.discount = '';
                this.subtotal = '';
                this.min_stock = '';
                this.stock = '';
                this.$v.$reset();
                // this.sellLine = this.getNewEmptySellLine();
                this.showNewSellLineModal = false;
            },

            getArticleById(){
                for(let i=0; i<this.articles.length; i++){
                    if(this.articles[i].id === this.article.id)
                        return this.articles[i];
                }
            },

            virtuallyDeleteSellLine(item){
                // this.consoleLog('removing sell line --------');
                let index = this.sellLineList.indexOf(item);
                this.sellLineList.splice(index, 1);
                // this.calcTotalArticleAndDiscount();
            },

            virtuallyAddNewSellLine(){
                this.consoleLog('SellLine response start');
                let newSellLine = {
                    articles_id: this.article.id,
                    detail: this.detail,
                    sold_quantity: this.sold_quantity,
                    quantity_to_be_delivery: this.quantity_to_be_delivery,
                    sell_price: this.sell_price,
                    discount: this.discount ? this.discount : 0,
                    // subtotal: this.subtotal,
                    subtotal: this.computedSellLineSubtotal,
                    article: this.getArticleById(),
                };

                this.consoleLog('SellLine response', this.aTItemLineIndexEdit);
                if(this.aTItemLineIndexEdit > -1){
                    this.$emit('onItemUpdated', {
                        item: newSellLine,
                        index: this.aTItemLineIndexEdit,
                    });
                }else {
                    this.$emit('onItemAdded', newSellLine);
                }
                this.closeSellLineDialog();
            },

            // searchArticle: _.debounce((vm) => {
            //     if (!vm.searchArticleField) return;
            //     vm.isLoadingArticles= true;

            //     //Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + vm.getToken;
            //     Vue.axios.get('article/search/' + vm.searchArticleField)
            //         .then(response => {
            //             vm.consoleLog(response);
            //             if (!response.data.success) {
            //                 //do nothing
            //                 return;
            //             }

            //             vm.articles = response.data.response;
            //             vm.articles.push({
            //                 id: -1,
            //                 // name: 'Adicionar novo funcionario'
            //                 name: vm.searchArticleField ? vm.searchArticleField : 'a'
            //             })


            //         }).catch(error => {
            //         // do nothing
            //     }).finally(() => {
            //         vm.isLoadingArticles = false
            //     });
            // }, 700),

            // onArticleAddOrEdited(vm){
            //     eventBus.$on('onArticleAdded', function(article){
            //         try{
            //             // if(vm.selectedUser.id < 1){
            //             vm.consoleLog('Article add event received, Name: '+article.name+'  |  Id: '+article.id);
            //             vm.articles.unshift(article);
            //             vm.article = article;
            //             vm.selectedArticle = this.getNewUser();
            //             // }
            //         }catch (e) {
            //             // vm.consoleLog(e);
            //             vm.showSnackBar('Ocorreu um erro ao adicionar artigo', 'error');
            //         }
            //     })
            // },
            prepareVariablesForArticleFormModal(){
                this.extra_modal_loading = true;
                try{
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get('article/extra/'+this.selectedSell.users_made_id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.showSnackBar('Erro ao atualizar artigo', 'error');
                                return;
                            }
                            this.article_types = response.data.response.articleTypes;

                            this.showArticleModal = true;
                        }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao atualizar artigo', 'error');
                    }).finally( ()=> {
                        this.extra_modal_loading = false;
                        // this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao atualizar empresa!', 'error');
                    this.consoleLog(e);
                    this.extra_modal_loading = false;
                    this.loading_modal = false;
                }
            },
            /////New User from form modal - End
        },

        computed: {
            additionToStock(){
                let x = this.articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE ? '+' : '-';
                return x+''+this.sold_quantity;
            },
            
            strMinStockHint(){
                return this.stockPrevision <= this.min_stock ? 'valor min. atingido' : '';
            },

            strNoStockHint(){
                return this.stockPrevision <= 0 ? 'Stock esgotado' : '';
            },

            quantity_to_be_delivery(){
                if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_SELL){
                    let res = this.stockPrevision < 0 ? this.stockPrevision : 0;
                    return res < 0 ? res*(-1) : res;
                }
                return 0;
            },

            stockPrevision(){
                if(this.article && this.article_type !== Types.article.SERVICO){
                    if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE){
                        return this.stock + this.sold_quantity;
                    }else{
                        // this.consoleLog('this.article.stock', this.article.stock);
                        // this.consoleLog('this.sold_quantity', this.sold_quantity);
                        return this.article.stock - this.sold_quantity;
                    }
                }
                return 0;
            },

            showNewSellLineModal:{
                get(){
                    return this.$store.getters.getShowNewSellLineModal;
                },
                set(value){
                    this.$store.dispatch('setShowNewSellLineModal', value);
                }
            },
            articles: {
                get(){
                    return this.$store.getters.getArticles;
                },
                set(value){
                    this.$store.dispatch('setArticles', value);
                }
            },

            sellLine: {
                get() {
                    return this.$store.getters.getSelectedArticleInSellLine;
                },
                set(value) {
                    this.$store.dispatch('setSelectedArticleInSellLine', value);
                }
            },

            discountHint(){
                if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE) return ''
                return this.agreed_discount > 0 && this.discount !== this.agreed_discount
                    ? 'O cliente tem desconto de '+this.agreed_discount+'%' : '';
            },

            articleErrors(){
                const errors = [];
                if (!this.$v.article.$dirty) return errors;
                !this.$v.article.required && errors.push('Escolha um artigo');
                return errors
            },
            detailErros(){
                const errors = [];
                if (!this.$v.detail.$dirty) return errors;
                !this.$v.detail.maxLength && errors.push('Máximo de 60 caracteres');
                return errors
            },
            soldQuantityErrors(){
                const errors = [];
                if (!this.$v.sold_quantity.$dirty) return errors;
                !this.$v.sold_quantity.minValue && errors.push('Não negativo');
                !this.$v.sold_quantity.required && errors.push('Introduza uma quantidade');
                return errors
            },
            costValueErros(){
                const errors = [];
                if (!this.$v.sell_price.$dirty) return errors;
                !this.$v.sell_price.minValue && errors.push('Não negativo');
                !this.$v.sell_price.required && errors.push('Introduza um preço');
                return errors
            },
            discountErrors(){
                const errors = [];
                if (!this.$v.discount.$dirty) return errors;
                !this.$v.discount.maxValue && errors.push('Inferior a 101');
                !this.$v.discount.minValue && errors.push('Não negativos');
                return errors
            },
            subtotalErrors(){
                const errors = [];
                if (!this.$v.subtotal.$dirty) return errors;
                !this.$v.subtotal.minValue && errors.push('Introduza número não negativo');
                !this.$v.subtotal.required && errors.push('Artigo não calculado ainda');
                return errors
            },

            computedSellLineSubtotal(){
                let controlFinalRes = 1; //Possible values are (1 or 0). If(1)=>final result is maintained else it is zeroed
                let subtotal=0, price=0;
                if(this.sellLine && this.articles){

                    price = this.sell_price;

                    let tempDiscount = (price * parseInt(this.sold_quantity)) * this.discount / 100;

                    subtotal = price * parseInt(this.sold_quantity) - tempDiscount;

                    this.calculateStockPrevision();

                    if(parseInt(this.sold_quantity) < 0 || this.discount < 0 ) subtotal = 0;

                }
                return this.roundToTwoDecimals(subtotal*controlFinalRes);
            },
        },



    }
</script>

<style scoped>

</style>